<div class="main-section">
    <div class="title-section" (click)="toggle()">
        <label [ngClass]="!collapsedValue ? 'text-dark-color' : 'text-light-color'">{{
      title() | titlecase
    }}</label>
        <span class="d-flex" [ngClass]="!collapsedValue ? 'arrow-up' : 'arrow-down'"><img src="/assets/images/down-arrow.svg" class="down-arrow-icon" /></span>
    </div>
    <div class="block" [@collapse]="collapsedValue">
        <ng-content></ng-content>
    </div>
</div>